<h1 mat-dialog-title>Pytanko !</h1>
<div mat-dialog-content>
	<div class="mb-6">
		<div class="mb-3">
			<h5>Czy chcesz zmienić również dla wypoczynków ?</h5>
			<h5>Pamiętaj dojazd własny</h5>
			<div class="mb-6">
				<button
					class="me-2"
					mat-raised-button
					color="primary"
					cdkFocusInitial
					(click)="changeOfferTerms('true')"
				>
					Tak
				</button>
				<button
					class="me-2"
					mat-raised-button
					color="primary"
					cdkFocusInitial
					(click)="changeOfferTerms('false')"
				>
					Nie
				</button>
			</div>
			<div class="mb-3"></div>
		</div>
	</div>
</div>
